import { render, staticRenderFns } from "./BlockablesNavbar.vue?vue&type=template&id=175741da&scoped=true&"
import script from "./BlockablesNavbar.vue?vue&type=script&lang=js&"
export * from "./BlockablesNavbar.vue?vue&type=script&lang=js&"
import style0 from "./BlockablesNavbar.vue?vue&type=style&index=0&id=175741da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175741da",
  null
  
)

export default component.exports